import { render } from "./BibimbapView.vue?vue&type=template&id=29d3174d"
import script from "./BibimbapView.vue?vue&type=script&lang=js"
export * from "./BibimbapView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__